import { render, staticRenderFns } from "./ChannelCredentialsByStoreCmp.vue?vue&type=template&id=838407a6&scoped=true&"
import script from "./ChannelCredentialsByStoreCmp.vue?vue&type=script&lang=js&"
export * from "./ChannelCredentialsByStoreCmp.vue?vue&type=script&lang=js&"
import style0 from "./ChannelCredentialsByStoreCmp.vue?vue&type=style&index=0&id=838407a6&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "838407a6",
  null
  
)

export default component.exports